/* =============================================================
   Bikelife CRO theme — global.js (vanilla, sans dépendance)
   ============================================================= */
(function () {
  'use strict';
  const theme = (window.theme = window.theme || {});
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const debounce = (fn, wait) => { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); }; };
  theme.$ = $; theme.$$ = $$; theme.debounce = debounce;

  /* ---------- Toast ---------- */
  let toastEl;
  theme.toast = function (message, duration) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = message; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), duration || 2200);
  };

  /* ---------- Drawers (menu, panier, filtres) ---------- */
  const backdrop = $('#DrawerBackdrop');
  let openDrawer = null;
  let lastFocus = null;

  theme.openDrawer = function (id) {
    const drawer = typeof id === 'string' ? document.getElementById(id) : id;
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) theme.closeDrawer(true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (backdrop) { backdrop.hidden = false; requestAnimationFrame(() => backdrop.classList.add('is-open')); }
    document.body.classList.add('drawer-open');
    openDrawer = drawer;
    $$('[data-drawer-open="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const f = drawer.querySelector('input:not([type=hidden]), button, a, select, textarea'); (f || drawer).focus({ preventScroll: true }); }, 60);
  };
  theme.closeDrawer = function (keepBackdrop) {
    if (!openDrawer) return;
    const drawer = openDrawer;
    drawer.classList.remove('is-open');
    $$('[data-drawer-open="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    if (!keepBackdrop) {
      if (backdrop) { backdrop.classList.remove('is-open'); setTimeout(() => { if (!openDrawer) backdrop.hidden = true; }, 300); }
      document.body.classList.remove('drawer-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); theme.openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); theme.closeDrawer(); return; }
    if (e.target === backdrop) theme.closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openDrawer) theme.closeDrawer();
    const sm = $('[data-search-modal].is-open'); if (sm) closeSearch();
  });

  /* ---------- Header : ombre au scroll ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Recherche + prédictive ---------- */
  const searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open'); document.body.classList.add('drawer-open');
    setTimeout(() => { const i = $('[data-predictive-search-input]', searchModal); if (i) i.focus(); }, 50);
  }
  function closeSearch() { if (!searchModal) return; searchModal.classList.remove('is-open'); document.body.classList.remove('drawer-open'); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    else if (searchModal && e.target === searchModal) closeSearch();
  });
  const psInput = $('[data-predictive-search-input]');
  const psResults = $('[data-predictive-search-results]');
  if (psInput && psResults && window.routes && window.routes.predictive_search_url) {
    let controller;
    const run = debounce(() => {
      const q = psInput.value.trim();
      if (q.length < 2) { psResults.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      fetch(url, { signal: controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-predictive-search-content]');
          psResults.innerHTML = content ? content.outerHTML : '';
        })
        .catch(() => {});
    }, 250);
    psInput.addEventListener('input', run);
  }

  /* ---------- Quantités (+ / −) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    if (!input) return;
    const step = Number(input.step) || 1;
    const min = input.min !== '' ? Number(input.min) : 0;
    const max = input.max !== '' ? Number(input.max) : Infinity;
    let val = Number(input.value) || 0;
    val = btn.name === 'plus' ? val + step : val - step;
    val = Math.max(min, Math.min(max, val));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Panier AJAX ---------- */
  const cart = (theme.cart = {});
  const cartDrawer = () => $('[data-cart-drawer]');

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count > 0 ? count : ''; });
  }
  function replaceDrawer(sectionHtml) {
    const drawer = cartDrawer();
    if (!drawer || !sectionHtml) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
    updateCartCount(Number(fresh.getAttribute('data-item-count') || 0));
  }
  function setLoading(state) { const d = cartDrawer(); if (d) d.classList.toggle('is-loading', state); }
  function showCartError(msg) {
    const box = $('[data-cart-errors]');
    if (box) { box.textContent = msg; setTimeout(() => { box.textContent = ''; }, 5000); } else theme.toast(msg, 4000);
  }

  cart.add = function (formData, opts) {
    opts = opts || {};
    if (!(formData instanceof FormData)) { const fd = new FormData(); Object.keys(formData).forEach((k) => fd.append(k, formData[k])); formData = fd; }
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    setLoading(true);
    return fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(async (r) => { const data = await r.json(); if (!r.ok || data.status) throw new Error(data.description || data.message || window.themeStrings.cartError); return data; })
      .then((data) => {
        if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer']);
        else return cart.refresh();
        return data;
      })
      .then((data) => {
        setLoading(false);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        if (opts.open !== false) { if (cartDrawer()) theme.openDrawer(cartDrawer()); else theme.toast(window.themeStrings.added); }
        return data;
      })
      .catch((err) => { setLoading(false); throw err; });
  };

  cart.change = function (line, quantity) {
    setLoading(true);
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(async (r) => { const data = await r.json(); if (!r.ok || data.status) throw new Error(data.description || data.message || window.themeStrings.cartError); return data; })
      .then((data) => {
        if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer']);
        updateCartCount(data.item_count);
        setLoading(false);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        if ($('[data-cart-page]')) window.location.reload();
        return data;
      })
      .catch((err) => { setLoading(false); showCartError(err.message); });
  };

  cart.refresh = function () {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then((r) => r.text())
      .then((html) => { replaceDrawer(html); })
      .catch(() => {});
  };

  // Icône panier → tiroir
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    if (cartDrawer()) { e.preventDefault(); theme.openDrawer(cartDrawer()); }
  });

  // Quick-add (cartes produit, shop the look, cross-sell)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-quick-add-button]');
    if (btn) btn.classList.add('is-loading');
    cart.add(new FormData(form))
      .then(() => { if (btn) { btn.classList.remove('is-loading'); const t = btn.textContent; btn.textContent = window.themeStrings.added; setTimeout(() => { btn.textContent = t; }, 1800); } })
      .catch((err) => { if (btn) btn.classList.remove('is-loading'); theme.toast(err.message || window.themeStrings.cartError, 4000); });
  });

  // Changement de quantité et suppression dans le tiroir (délégation : le contenu est remplacé après chaque MAJ)
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-drawer] .quantity__input');
    if (!input) return;
    const line = Number(input.getAttribute('data-line'));
    cart.change(line, Number(input.value));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    const line = Number(rm.getAttribute('data-line'));
    if ($('[data-cart-page]') && !rm.closest('[data-cart-drawer]')) {
      cart.change(line, 0);
    } else cart.change(line, 0);
  });
  // Page panier : mise à jour à la volée des quantités
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-page] .quantity__input');
    if (!input) return;
    cart.change(Number(input.getAttribute('data-line')), Number(input.value));
  });

  /* ---------- Localisation (pays / langue) ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-localization-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- Tri & filtres (GET) ---------- */
  document.addEventListener('change', (e) => {
    const sort = e.target.closest('[data-sort-select]');
    if (sort && sort.form) { sort.form.submit(); return; }
    const facetForm = e.target.closest('[data-facets-form]');
    if (facetForm && e.target.matches('input[type=checkbox], select')) { submitFacets(facetForm); return; }
    if (facetForm && e.target.matches('input[type=number]')) submitFacetsDebounced(facetForm);
  });
  function submitFacets(form) {
    // On enlève les champs vides pour garder une URL propre
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    const base = window.location.pathname;
    window.location.href = base + (params.toString() ? '?' + params.toString() : '');
  }
  const submitFacetsDebounced = debounce(submitFacets, 700);
  document.addEventListener('submit', (e) => { const f = e.target.closest('[data-facets-form]'); if (f) { e.preventDefault(); submitFacets(f); } });

  /* ---------- Estimation de livraison (jours ouvrés) ---------- */
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function fmtDate(d) {
    try { return new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { day: 'numeric', month: 'short' }).format(d); }
    catch (e) { return d.toLocaleDateString(); }
  }
  $$('[data-delivery-estimate]').forEach((el) => {
    const min = Number(el.getAttribute('data-min-days')) || 5;
    const max = Number(el.getAttribute('data-max-days')) || 12;
    const target = el.querySelector('[data-delivery-text]');
    if (!target || !window.themeStrings || !window.themeStrings.shippingEstimate) return;
    const now = new Date();
    const text = window.themeStrings.shippingEstimate.replace('[min]', fmtDate(addBusinessDays(now, min))).replace('[max]', fmtDate(addBusinessDays(now, max)));
    target.innerHTML = '<span class="delivery__date">' + text + '</span>';
  });

  /* ---------- UGC : lecture vidéo au tap ---------- */
  document.addEventListener('click', (e) => {
    const media = e.target.closest('[data-ugc-media]');
    if (!media) return;
    const video = media.querySelector('video');
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      $$('[data-ugc-media] video').forEach((v) => { if (v !== video && !v.paused) { v.pause(); v.closest('[data-ugc-media]').classList.remove('is-playing'); } });
      video.muted = false;
      video.play().then(() => media.classList.add('is-playing')).catch(() => { video.muted = true; video.play(); media.classList.add('is-playing'); });
    } else { video.pause(); media.classList.remove('is-playing'); }
  });

  /* ---------- Shop the look : points ↔ liste ---------- */
  $$('[data-shop-the-look]').forEach((section) => {
    const items = $$('[data-look-item]', section);
    const activate = (id) => {
      items.forEach((it) => it.classList.toggle('is-active', it.getAttribute('data-look-item') === id));
      $$('[data-hotspot]', section).forEach((h) => h.classList.toggle('is-active', h.getAttribute('data-hotspot') === id));
    };
    section.addEventListener('click', (e) => {
      const spot = e.target.closest('[data-hotspot]');
      if (!spot) return;
      const id = spot.getAttribute('data-hotspot');
      activate(id);
      const item = section.querySelector('[data-look-item="' + id + '"]');
      if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    section.addEventListener('mouseover', (e) => { const it = e.target.closest('[data-look-item]'); if (it) activate(it.getAttribute('data-look-item')); });
  });

  /* ---------- Recommandations produit (Section Rendering API) ---------- */
  $$('[data-product-recommendations]').forEach((el) => {
    const url = el.getAttribute('data-url');
    if (!url) return;
    const load = () => fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(() => {});
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => { if (entries.some((en) => en.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Scroll vers le formulaire produit (bouton avant/après) ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-scroll-to-form]');
    if (!link) return;
    const form = $('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = $('[data-personalization-input]:not(:disabled)');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 500);
  });

  /* ---------- Dialogs (fermeture) ---------- */
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-modal-close]');
    if (close) { const dlg = close.closest('dialog'); if (dlg) dlg.close(); return; }
    const dlg = e.target.closest('dialog');
    if (dlg && e.target === dlg) dlg.close();
  });

  /* ---------- Adresses client : provinces + suppression ---------- */
  $$('[data-address-country-select]').forEach((select) => {
    const id = select.getAttribute('data-address-id');
    const provinceWrap = document.getElementById('AddressProvinceContainer' + id);
    const provinceSelect = document.getElementById('AddressProvince' + id);
    const update = () => {
      const opt = select.options[select.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      if (!provinceSelect || !provinceWrap) return;
      provinceSelect.innerHTML = '';
      if (provinces.length === 0) { provinceWrap.style.display = 'none'; return; }
      provinces.forEach((p) => { const o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; if (p[0] === provinceSelect.getAttribute('data-default')) o.selected = true; provinceSelect.appendChild(o); });
      provinceWrap.style.display = '';
    };
    const def = select.getAttribute('data-default');
    if (def) Array.from(select.options).forEach((o) => { if (o.value === def || o.textContent === def) o.selected = true; });
    select.addEventListener('change', update); update();
  });
  document.addEventListener('click', (e) => {
    const del = e.target.closest('[data-address-delete]');
    if (!del) return;
    if (!confirm(del.getAttribute('data-confirm') || 'Supprimer ?')) return;
    const form = document.createElement('form'); form.method = 'post'; form.action = del.getAttribute('data-target');
    const m = document.createElement('input'); m.type = 'hidden'; m.name = '_method'; m.value = 'delete'; form.appendChild(m);
    document.body.appendChild(form); form.submit();
  });

  /* ---------- Compteur de caractères (personnalisation) ---------- */
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-personalization-input]');
    if (!input) return;
    const counter = input.parentElement.querySelector('[data-counter]');
    if (counter && input.maxLength > 0) counter.textContent = input.value.length + '/' + input.maxLength;
    if (input.value.trim() !== '') { input.classList.remove('is-invalid'); const err = input.closest('[data-personalization-field]'); if (err) { const m = err.querySelector('[data-field-error]'); if (m) m.hidden = true; } }
  });
})();
